<template>
  <div>
    <loading v-if="isLoading" />
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card class="email-dialog">
        <v-toolbar color="#006699" dark flat>
          <v-toolbar-title>
            <v-icon left>mdi-email-edit</v-icon>
            Alterar Email
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="fecharComponente">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pt-4">
          <v-container>
            <v-form ref="form" v-model="formValid" lazy-validation>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field 
                    v-model="usuario.nomeUsuario" 
                    label="Nome" 
                    outlined
                    dense
                    disabled
                    prepend-inner-icon="mdi-account"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field 
                    v-model="usuario.Usuario_username" 
                    label="Email atual" 
                    outlined
                    dense
                    disabled
                    prepend-inner-icon="mdi-email"
                  ></v-text-field>
                </v-col>
              </v-row>
              
              <v-row>
                <v-col cols="12">
                  <v-text-field 
                    :disabled="disabilitaRole" 
                    :rules="ruleEmailRequired" 
                    v-model="novoEmail" 
                    label="Novo email"
                    outlined
                    dense
                    clearable
                    prepend-inner-icon="mdi-email-outline"
                    placeholder="Digite o novo email"
                    class="new-email-field"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn 
            color="red darken-1" 
             dark
             small
            @click="fecharComponente"
            class="mr-2" 
          >
            Cancelar
          </v-btn>
          <v-btn 
            color="#006699" 
            depressed
            dark
            small
            :loading="isLoading"
            @click="salvarEmail"
          >
            <v-icon left color="white">mdi-content-save</v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "../../../../plugins/axios";
import Swal from "sweetalert2";
import loading from "../../../../components/loading.vue";
const ls = require("local-storage");

export default {
  props: ["usuario"],
  components: {
    loading
  },

  data: () => ({
    disabilitaRole: false,
    novoEmail: "",
    dialog: true,
    formValid: true,
    isLoading: false,
    ruleEmailRequired: [
      (value) => value.length <= 50 || "Máximo de 50 caracteres",
      (value) => !!value || "Campo obrigatório",
      (value) => { 
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Email inválido";
      },
    ]
  }),

  computed: {
    Instituicao() {
      return ls.get("i_id");
    },
    role() {
      return ls.get("role");
    },
  },

  created() {
    this.disabilitaRole = this.usuario.autorizacoes_nome === "ROLE_EST";
  },

  methods: {
    async salvarEmail() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        
        try {
          const params = {
            email: this.novoEmail,
            pkUsuario: this.usuario.pkUsuario
          };

          const response = await axios.post("/alterarsenhaUsuario", params).then((res) => res.data);
          
          if (response.affectedRows >= 1) {
            Swal.fire({
              title: 'Sucesso',
              text: 'Email alterado com sucesso!',
              icon: 'success',
              timer: 2000,
              showConfirmButton: false
            });
            this.fecharComponente();
          } else if (response.messages == 'Duplicate') {
            Swal.fire({
              title: 'Atenção',
              text: 'Este email já está registrado no sistema',
              icon: 'warning',
              confirmButtonText: 'Entendi'
            });
          }
        } catch (error) {
          Swal.fire({
            title: 'Erro',
            text: 'Ocorreu um erro ao alterar o email',
            icon: 'error',
            confirmButtonText: 'Fechar'
          });
        } finally {
          this.isLoading = false;
        }
      }
    },
    
    fecharComponente() {
      this.novoEmail = "";
      this.$emit("fecharComponente", false);
    },
  },
};
</script>

<style scoped>
.email-dialog {
  border-radius: 8px;
}

.dialog-actions {
  padding: 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}

.new-email-field {
  margin-top: 8px;
}

/* Efeitos de transição */
.v-text-field {
  transition: all 0.3s ease;
}

/* Melhoria no foco dos campos */
.v-text-field--outlined:focus-within >>> fieldset {
  border-color: var(--v-primary-base) !important;
  border-width: 2px !important;
}

/* Responsividade */
@media (max-width: 600px) {
  .email-dialog {
    margin: 0;
    border-radius: 0;
  }
  
  .v-card__text {
    padding: 16px;
  }
}
</style>